




























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import OzIcon from 'library/v4/components/oz-icon.vue'

@Component({
  components: { OzIcon },
})
export default class SurfacePostCommentsIcon extends Vue {
  @Prop() commentIds!: [string | number]
  @Prop() colorScheme!: 'light' | 'dark'

  get commentsListLength(): number {
    return this.commentIds.length
  }

  showCommentsPanel(): void {
    this.$emit('show-comments-panel')
  }
}
